import React from "react";

/** Tiny sparkle star — decorative */
export const SparkleStar = ({
    size = 16,
    color = "#FBBF24",
    className = "",
    style = {},
}) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        style={style}
        aria-hidden="true"
    >
        <path
            d="M12 2 L14 10 L22 12 L14 14 L12 22 L10 14 L2 12 L10 10 Z"
            fill={color}
        />
    </svg>
);

/** Solid dot */
export const AccentDot = ({
    size = 10,
    color = "#EC4899",
    className = "",
    style = {},
}) => (
    <span
        className={`inline-block rounded-full ${className}`}
        style={{
            width: size,
            height: size,
            backgroundColor: color,
            boxShadow: `0 0 ${size}px ${color}80`,
            ...style,
        }}
        aria-hidden="true"
    />
);

/** Small triangle accent */
export const AccentTriangle = ({
    size = 16,
    color = "#14B8A6",
    className = "",
    style = {},
}) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        className={className}
        style={style}
        aria-hidden="true"
    >
        <path d="M12 3 L22 21 L2 21 Z" fill={color} />
    </svg>
);

/** Scattered cluster of decorative shapes for around-hero use */
export const FloatingAccents = () => (
    <>
        <SparkleStar
            size={20}
            color="#FBBF24"
            className="absolute"
            style={{ top: "8%", left: "-4%" }}
        />
        <AccentDot
            size={12}
            color="#EC4899"
            className="absolute"
            style={{ top: "20%", right: "-2%" }}
        />
        <AccentTriangle
            size={18}
            color="#14B8A6"
            className="absolute"
            style={{ bottom: "12%", left: "-2%" }}
        />
        <AccentDot
            size={8}
            color="#3B82F6"
            className="absolute"
            style={{ bottom: "30%", right: "8%" }}
        />
        <SparkleStar
            size={14}
            color="#8B5CF6"
            className="absolute"
            style={{ top: "55%", left: "-5%" }}
        />
    </>
);
